import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const InvitePage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const refCode = searchParams.get('ref');

    useEffect(() => {
        // Basic smart link logic
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        // Is iOS?
        if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            // In the future: redirect to App Store
            // window.location.href = 'https://apps.apple.com/app/idYOUR_APP_ID';

            // For now, redirect to mobile web registration
            window.location.replace(`/register?ref=${refCode || ''}`);
            return;
        }

        // Is Android?
        if (/android/i.test(userAgent)) {
            // In the future: redirect to Play Store
            // window.location.href = 'https://play.google.com/store/apps/details?id=YOUR_PACKAGE_NAME';

            // For now, redirect to mobile web registration
            window.location.replace(`/register?ref=${refCode || ''}`);
            return;
        }

        // Desktop/Other - redirect to web registration
        window.location.replace(`/register?ref=${refCode || ''}`);
    }, [refCode]);

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default'
            }}
        >
            <CircularProgress size={60} sx={{ mb: 4 }} />
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Taking you to Ride Club...
            </Typography>
        </Box>
    );
};

export default InvitePage;
